import React from 'react';

const TEMPLATE_LIBRARY = [
  {
    id: 'purchase-approval',
    name: 'Purchase Order Approval',
    description: 'Multi-step approval workflow for purchase orders',
    icon: '📋',
    steps: ['Manager Review', 'Finance Sign-off', 'CFO Approval']
  },
  {
    id: 'invoice-sync',
    name: 'Invoice to ERP Sync',
    description: 'Automatically sync invoices from suppliers to Epicor',
    icon: '📄',
    steps: ['Extract from PDF', 'Match to PO', 'Post to ERP']
  },
  {
    id: 'supplier-price-update',
    name: 'Supplier Price Update',
    description: 'Update supplier pricing from email or file upload',
    icon: '💰',
    steps: ['Parse Price List', 'Validate Prices', 'Update Vendor Master']
  },
  {
    id: 'customer-order',
    name: 'Customer Self-Service Order',
    description: 'Allow customers to place orders via portal',
    icon: '🛒',
    steps: ['Validate Inventory', 'Create SO', 'Send Confirmation']
  }
];

export default function Templates() {
  return (
    <div className="flex-1">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Workflow Templates</h2>
          <p className="text-gray-600">Pre-built templates to get started quickly</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TEMPLATE_LIBRARY.map((template) => (
            <div key={template.id} className="card p-6 hover:shadow-lg transition-shadow cursor-pointer">
              <div className="text-4xl mb-3">{template.icon}</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{template.name}</h3>
              <p className="text-sm text-gray-600 mb-4">{template.description}</p>

              <div className="mb-4">
                <p className="text-xs font-medium text-gray-500 mb-2">Steps:</p>
                <div className="flex flex-wrap gap-2">
                  {template.steps.map((step, idx) => (
                    <span key={idx} className="badge badge-success">{step}</span>
                  ))}
                </div>
              </div>

              <button className="w-full btn btn-primary">Use Template</button>
            </div>
          ))}
        </div>

        <div className="mt-12 card p-6 kairon-gradient text-white">
          <h3 className="text-xl font-bold mb-2">📝 Custom Workflow</h3>
          <p className="mb-4 opacity-90">Need something different? Build a custom workflow from scratch</p>
          <button className="btn bg-white text-blue-600 hover:bg-gray-100">Create Custom Workflow</button>
        </div>
      </div>
    </div>
  );
}
